import { useEffect } from 'react';

import {
  useAdminEnrollmentManagementActions,
} from './AdminEnrollmentManagementContext';

import {
  getEnrollmentManagement,
} from './restApi';

const AdminEnrollmentManagementLoader = () => {
  const { initializeState, onResponse, onError } = useAdminEnrollmentManagementActions();

  useEffect(() => {
    initializeState();
  }, []);

  useEffect(() => {
    getEnrollmentManagement({
      onResponse,
      onError,
    });
  }, []);

  return null;
};

export default AdminEnrollmentManagementLoader;
